import cloneDeep from 'lodash/cloneDeep';
import { ProductStaticDataType } from 'types/ProductPageV2/Products';

export function filterLargeSizeData(
  data: ProductStaticDataType
): ProductStaticDataType {
  const clonedData = cloneDeep(data);
  const { cups: originalCups, sizes: originalSizes, variants } = clonedData;
  const variantsSkus: string[] = [];
  const sizes: string[] = [];
  const cups: string[] = [];

  for (const [color, skus] of Object.entries(variants)) {
    for (const [sku, variant] of Object.entries(skus)) {
      const {
        Attributes: { bonnet, codeTaille, estGrandeTaille, SKUReelle },
      } = variant;

      if (!Number(estGrandeTaille.Value)) {
        delete skus[sku];
        continue;
      }

      variantsSkus.push(SKUReelle.Value);
      if (!sizes.includes(codeTaille.Value)) sizes.push(codeTaille.Value);
      if (bonnet?.Value && !cups.includes(bonnet.Value))
        cups.push(bonnet.Value);
    }

    if (!Object.keys(skus).length) delete variants[color];
  }

  const orderedSizes = originalSizes.filter(size => sizes.includes(size));
  const orderedCups = originalCups.filter(cup => cups.includes(cup));

  return {
    ...clonedData,
    ...{ cups: orderedCups, sizes: orderedSizes, variants, variantsSkus },
  };
}
